export const config = {
  title: 'Text to video',
  EbookTopic: "Write About Ebook here..",
  ContentTopic:"Enter your prompt or story to generate video about.",
  Keypoints : 'Select Tone',
  Keypointsplaceholder:'',
  SupportiveInput: 'Select Length',
  Input2splaceholder:"Hi Maya! Lets Catch-up and discuss the project in detail",
  //color: '#FF3A12',
  Writetab:"Create Video",
  color:'#5D0AD1',
  getacceseline1: ' Unlimited Text to Video Generator',
  getacceseline2: ' Unlimited HD Exports',
  getacceseline3: ' No Watermarks',
  getacceseline4: ' Ads - Free',





  //color used across web  
  primaryColor: '#5D0AD1',
  tabsColor: '#5D0AD1',


  //images used accross web
  logo: require('../assets/vector.svg').default,

  home: require('../assets/filled.svg').default,
  homelp: require('../assets/filled leftp.svg').default,
  privacy: require('../assets/description.svg').default,
  privacylp: require('../assets/description leftp.svg').default,
  termsimg: require('../assets/termsimg.svg').default,
  refundimg: require('../assets/refundimg.svg').default,
  blogimg: require('../assets/blogs.svg').default,

  hamburger: require('../assets/USSSA - Icons_Hamburger Menu.svg').default,
  crown: require('../assets/crown 1.svg').default,
  frame: require('../assets/vector_slider.svg').default,
  proicon: require('../assets/pro.svg').default,
  upgradetopro: require('../assets/upgradetopro.png')  ,
  righticon: require('../assets/right.svg').default,
  Backbutton: require('../assets/arrow-left.svg').default,  
  Buybutton: require('../assets/arrow long right.svg').default,
  book: require('../assets/book.svg').default, 
logoicon: require('../assets/logoIcon.svg').default,



//landingpage images

logolanding: require('../assets/logolanding.svg').default,
Heroimagesvg: require('../assets/heroimagesvg.svg').default,

Heroropeimage: require('../assets/herorope.svg').default,
Videoshowcase1: '../assets/Video1.mp4',
Videoshowcase2: '../assets/Video2.mp4',
Videoshowcase3: '../assets/Video3.mp4',
step1: require('../assets/step1.svg').default,
step2: require('../assets/step2.svg').default,
step3: require('../assets/step3.svg').default,
step4: require('../assets/step4.svg').default,


check_point_white: require('../assets/check_white.svg').default,
check_point: require('../assets/check_point.svg').default,
check_point_locked_white: require('../assets/check_point_locked.svg').default,

  //api endpoitns accross web
 // apiEndpoint: 'http://localhost/projectA/api',
baseURL:"https://generator.video/Backend",
//baseURL:"http://localhost",
  

  "FAQtitle": "How to Use Text to video ?",
  "points": [
    {
      "step": "Prompt Video:",
      "details": [
        "Enter Prompt or story for your video. Select the Duration, background music and ascpect ratio. Click 'Generate', and your video will be ready in 20-40 seconds."
      ]
    },
    {
      "step": "Refine Results:",
      "details": [
        "For better results, try generating multiple versions by adjusting your inputs."
      ]
    }
  ],



  //privacy page 
  "privacyTitle": "Privacy Policy for Text to video ",
  "privacyEffectiveDate": "13-7-2023",
  "privacyPoints": [
    {
      "heading": "1. Information We Collect",
      "subsections": [
        {
          "heading": "1.1 Personal Information",
          "content": [
            "We may collect personal information that you provide directly to us when using the App. This includes:",
            "- Your name, email address, and other contact information when you sign up or contact us for support.",
            "- Story content and other user-generated content you provide within the App.",
            "- Communication and interaction details when you communicate with other users or us through the App."
          ]
        },
        {
          "heading": "1.2 Usage Information",
          "content": [
            "When you use the App, we may automatically collect certain information about your device and usage patterns, including:",
            "- Device information (such as model, operating system version, unique device identifiers).",
            "- Log information (such as IP address, access dates and times, and referring/exit pages).",
            "- App usage data, including the features you use, the pages you visit, and the actions you take."
          ]
        }
      ]
    },
    {
      "heading": "2. Use of Information",
      "subsections": [
        {
          "heading": "2.1 Provide and Improve the App",
          "content": [
            "We use the collected information to provide, maintain, and improve the functionality and performance of the App. This includes:",
            "- Personalizing your experience and providing you with tailored content.",
            "- Enhancing the App's security and detecting, preventing, and responding to potential fraud or security issues."
          ]
        }
      ]
    },
    {
      "heading": "3. Sharing Your Information",
      "content": [
        "- We do not share your personal information with third parties, except as required by law or with your explicit consent."
      ]
    },
    {
  "heading": "4. AI Processing",
  "content": [
    "User prompts may be processed by AI services solely for generating requested videos.",
    "Uploaded images are not used for facial recognition, identity cloning, or deepfake generation.",
    "We do not use uploaded images to create synthetic media of real individuals."
  ]
}
  ],






  "termandcondition": "Terms of Use Policy for Text to video ",
  "termandconditionEffectiveDate": "16-12-2024",
  "termandconditionPoints": [
    {
      "heading": "1. Introduction",
      "content": [
        "Welcome to our Text to video ! These terms of use outline the rules and regulations for the use of our mobile applications powered by AI technology. By accessing or using our apps, you agree to comply with these terms and conditions. If you do not agree with any part of these terms, you may not access or use our apps."
      ]
    },
    {
      "heading": "2. License",
      "content": [
        "Our apps are licensed to you on a limited, non-exclusive, non-transferable, and revocable basis. You may use our apps solely for your personal, non-commercial purposes and in accordance with these terms."
      ]
    },
    {
      "heading": "3. Restrictions",
      "subsections": [
        {
          "heading": "3.1 General Restrictions",
          "content": [
            "When using our apps, you must not:",
            "- Violate any applicable laws or regulations.",
            "- Infringe upon the rights of others.",
            "- Introduce any malicious code or software.",
            "- Attempt to gain unauthorized access to our apps or any related systems or networks.",
            "- Interfere with the proper functioning of our apps."
          ]
        },{
  "heading": "3.2 AI Safety and Prohibited Uses",
  "content": [
    "Users may not use Text to Video to create deepfake videos or images of real individuals.",
    "Users may not impersonate any person or create deceptive synthetic media.",
    "Our platform does not provide face swapping, identity cloning, or AI manipulation of photographs of real people.",
    "Where image uploads are available, uploaded images are used only as provided and are not transformed into deepfake content.",
    "We reserve the right to suspend accounts that attempt to misuse the platform for impersonation or deceptive content."
  ]
}
      ]
    },
    {
      "heading": "4. Intellectual Property",
      "content": [
        "All intellectual property rights in our apps, including but not limited to copyrights, trademarks, and patents, are owned by us or our licensors. You may not reproduce, modify, distribute, or otherwise use any of our intellectual property without our prior written consent."
      ]
    },
    
    {
      "heading": "5. Privacy",
      "content": [
        "We respect your privacy and are committed to protecting your personal information. Our Privacy Policy explains how we collect, use, and disclose your information when you use our apps. By using our apps, you consent to the collection, use, and disclosure of your information as described in our Privacy Policy."
      ]
    },
    {
      "heading": "6. Disclaimer",
      "content": [
        "Our apps are provided on an ‘as is’ and ‘as available’ basis. We make no warranties or representations of any kind, whether expressed or implied, regarding the operation or availability of our apps, or the accuracy, reliability, or completeness of any information provided through our apps."
      ]
    },
    {
      "heading": "7. Limitation of Liability",
      "content": [
        "In no event shall we be liable for any indirect, incidental, special, or consequential damages arising out of or in connection with the use of our apps. You agree to indemnify and hold us harmless from any claims, losses, or damages, including legal fees, arising out of your use of our apps or any violation of these terms."
      ]
    },
    {
  "heading": "8. AI Generated Content",
  "content": [
    "Text to Video generates original AI-assisted video content from user prompts.",
    "Users are responsible for ensuring they have permission to use any uploaded content.",
    "The Service must not be used to generate misleading, fraudulent, or deceptive content involving real individuals."
  ]
},
    {
      "heading": "9. Changes to Terms",
      "content": [
        "We reserve the right to modify or update these terms of use at any time. Any changes will be effective immediately upon posting the updated terms on our website. It is your responsibility to review these terms periodically for any changes."
      ]
    },
    {
      "heading": "10. Contact Us",
      "content": [
        "If you have any questions or concerns about these terms of use, please contact us at speedapps1010@gmail.com."
      ]
    }
  ],
  "refundTitle": "Refund & Cancellation Policy",
  "refundEffectiveDate": "15th August 2024",
  "refundPoints": [
    {
      "heading": "1. Refund Policy",
      "subsections": [
        {
          "heading": "1.1 Subscription Products",
          "content": [
            "Text to video provides digital products and services in the form of subscriptions. Due to the nature of our offerings, we maintain the following refund guidelines:",
            "- **Trial Periods**: If your subscription plan includes a trial period, you may cancel at any time during the trial to avoid charges. Refunds will not be applicable if the subscription is canceled after the trial period ends and the payment has been processed.",
            "- **30-Day Money-Back Guarantee**: We offer a 30-day money-back guarantee for first-time users. If you are not satisfied with our service, you may request a refund within 30 days of your initial purchase. After 30 days, no refunds will be issued.",
            "- **Refund Eligibility**: To be eligible for a refund, your request must meet the following conditions:",
            "  - The request is made within 30 days of the initial purchase.",
            "  - You must provide a valid reason for the refund request, such as technical issues with the software that cannot be resolved.",
            "- **Non-Refundable Subscriptions**: Subscription renewals are non-refundable. You can cancel your subscription at any time to prevent future charges, but refunds for renewal payments will not be issued.",
            "- **Exclusions**: Refunds are not applicable for:",
            "  - Any product purchased with a promotional discount or code.",
            "  - Multi-user or team licenses."
          ]
        },
        {
          "heading": "1.2 Process for Refund Requests",
          "content": [
            "To request a refund, please contact our customer support team at [support@aispeedapps.com] with your order details and the reason for your request. Refunds will be processed within 7-10 business days after approval. Funds will be credited back to the original payment method."
          ]
        }
      ]
    },
    {
      "heading": "2. Cancellation Policy",
      "subsections": [
        {
          "heading": "2.1 Canceling Subscriptions",
          "content": [
            "You can cancel your subscription at any time by logging into your Text to video account and navigating to the 'Subscriptions' section. Simply follow the cancellation instructions provided.",
            "- **Immediate Effect**: Once canceled, your subscription will not be renewed. You will continue to have access to the software until the end of your current billing cycle. After that period, your access to the software will be revoked.",
            "- **Future Billing**: If you cancel your subscription, you will not be charged for the next billing cycle. However, there are no prorated refunds for mid-cycle cancellations; you will have access until the current subscription period ends."
          ]
        },
        {
          "heading": "2.2 Involuntary Cancellations",
          "content": [
            "Text to video reserves the right to suspend or terminate your subscription at any time due to violations of our Terms of Service or any other breach of agreement. In such cases, no refunds will be issued."
          ]
        }
      ]
    },
    {
      "heading": "3. Contact Us",
      "content": [
        "If you have any questions or need assistance with your refund or cancellation, please reach out to our customer support team at:",
        "- **Text to video Support Team**",
        "- **Email**: speedapps1010@gmail.com",
        "- **Phone**: 8176851179",
        "- **Website**: [www.generator.video]"
      ]
    },
    {
      "heading": "4. Changes to This Policy",
      "content": [
        "Text to video reserves the right to modify this Refund & Cancellation Policy at any time. Any changes will be posted on our website and will take effect immediately. It is your responsibility to review this policy periodically."
      ]
    }
  ],
  FAQs: [
    {
      "question": "Can I use this Text to video for business purposes?",
      "answerFAQ": "Yes, it’s ideal for businesses! Use it to create promotional videos, explainer videos, and video marketing content for platforms like YouTube, Instagram, and TikTok."
    },
    {
      "question": "How long does it take to create a video?",
      "answerFAQ": "With the AI-powered video generator, you can create professional-quality script-to-video content in just a few minutes, making it perfect for quick social media posts and reels."
    },
    {
      "question": "What is a faceless video, and why should I create one?",
      "answerFAQ": "A faceless video is a video where no person appears on camera. It’s great for creators who prefer privacy or want to focus on content rather than appearance. This app makes faceless video creation easy and professional."
    },
    {
      "question": "Can I monetize the videos I create?",
      "answerFAQ": "Yes, you can monetize videos created using the app on platforms like YouTube, TikTok, and Instagram. Many creators use faceless explainer videos for affiliate marketing, product promotions, and ad revenue."
    },
    {
      "question": "Does the app provide royalty-free assets?",
      "answerFAQ": "Yes! The app offers a library of royalty-free music, images, and AI-generated visuals, ensuring your content is ready for commercial use without copyright issues."
    },
    {
      "question": "Is this app suitable for content creators?",
      "answerFAQ": "Absolutely! It’s designed for content creators looking to produce shorts, reels, TikTok videos, and social media marketing content quickly and effectively without technical skills."
    },
    {
      "question": "Can I create videos without writing a script?",
      "answerFAQ": "Yes! The app includes AI-based content suggestions, so even if you don’t have a script, you can quickly generate engaging AI explainer videos or social media posts."
    },
    {
      "question": "Does the app support different video formats and aspect ratios?",
      "answerFAQ": "Yes! It offers support for various formats and aspect ratios, including 16:9 for YouTube, 9:16 for TikTok and Instagram Reels, and 1:1 for other social platforms."
    },
    {
      "question": "How can I use this tool for video marketing?",
      "answerFAQ": "This app is a complete video marketing tool, helping marketers create engaging promotional content, product demos, and faceless explainer videos that boost brand visibility across platforms."
    },
    {
      "question": "Can I create videos for educational purposes?",
      "answerFAQ": "Yes! The app is great for educators who want to create AI explainer videos, faceless video tutorials, or online course content quickly and effectively."
    },
    {
      "question": "Is there a limit to how many videos I can create?",
      "answerFAQ": "Depending on your subscription plan, you can generate unlimited or a set number of social media videos, shorts, and TikTok content."
    },
    {
      "question": "Does the app offer support for subtitles?",
      "answerFAQ": "Yes! You can add auto-generated subtitles to your text-to-video content, making it more accessible and engaging for viewers."
    },
    {
      "question": "How is this app different from traditional video editors?",
      "answerFAQ": "Unlike traditional editors, this app uses AI to automate the entire process, from script-to-video creation to adding visuals, music, and subtitles. It’s faster, easier, and perfect for faceless video creation and social media marketing."
    },
    {
      "question": "Can I use this app to create videos for multiple platforms at once?",
      "answerFAQ": "Yes! You can create videos optimized for multiple platforms like YouTube Shorts, Instagram Reels, and TikTok, all from a single script."
    }
  ],




};
